import { booleanField, hiddenField, stringField } from 'common/utils/form/fieldTypes';

const config = {
  organizations: {
    id: hiddenField(),
    name: stringField(),
    active: booleanField()
  }
};

export default config;
